import { Query } from 'graphql/generated/graphqlTypes';
import { generateMockLocation } from 'mocks/graphqlMocks/location';
import { mockedGetLocationWithDoorsForTenantDataAdmin } from './getLocationWithDoorsForTenant';

export function mockedGetLocationsWithoutNestedResolversData(
  getLocationsForTenant: Query['getLocationsForTenant']
): Pick<Query, 'getLocationsForTenant'> {
  return { getLocationsForTenant };
}

export const mockedGetLocationsWithoutNestedResolversDataForQuery = mockedGetLocationsWithoutNestedResolversData([
  generateMockLocation({ id: 'TestGroup1', name: 'Test group 1' }),
  generateMockLocation({ id: 'TestGroup2', name: 'Test group 2' })
]);

// The same locations (and the ids of their doors) as the admin locations with doors, so the device pages keep the
// data they had before they used the slim query. The query only selects the `id`, `name` and `doors { id }` fields.
export const mockedGetLocationsWithoutNestedResolversDataAdmin = mockedGetLocationsWithoutNestedResolversData(
  mockedGetLocationWithDoorsForTenantDataAdmin.getLocationsForTenant
);
